module.exports = __webpack_public_path__ + "static/media/Loading_Img.d985ff34.svg";